import * as React from "react";

const SvgIcnBell = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M12.011 20.011c1.41 0 2.54-.773 2.86-2h3.402c.55 0 .893-.52.683-1.002l-.267-.577a18.124 18.124 0 01-1.677-7.349c0-2.845-2.187-5.083-5-5.083C9.2 4 7.026 6.236 7.026 9.1a18.181 18.181 0 01-1.692 7.33l-.268.576c-.223.454.138 1.005.682 1.005h3.403c.32 1.227 1.45 2 2.86 2zm-5.844-3l.074-.16A19.19 19.19 0 008.027 9.11C8.027 6.782 9.759 5 12.01 5c2.256 0 4 1.785 4 4.09a19.132 19.132 0 001.771 7.762l.074.159h-3.758l-.195.747c-.2.762-.916 1.253-1.892 1.253-.976 0-1.693-.49-1.892-1.253l-.195-.747H6.167z"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
            strokeWidth={1}
        />
    </svg>
);

export default SvgIcnBell;
